import { render, staticRenderFns } from "./TabelaPadrao.vue?vue&type=template&id=bc938670&scoped=true&"
import script from "./TabelaPadrao.vue?vue&type=script&lang=js&"
export * from "./TabelaPadrao.vue?vue&type=script&lang=js&"
import style0 from "./TabelaPadrao.vue?vue&type=style&index=0&id=bc938670&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc938670",
  null
  
)

export default component.exports